import type { CustomParamsSerializer } from 'axios';

/**
 * Consider applying globally or asking backend to support the default axios serializer
 * if this is going to be needed in many places
 */
export const arrayQueryParamsSerializer: CustomParamsSerializer = params => {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params).filter(
    ([, key]) => key !== undefined,
  )) {
    if (Array.isArray(value)) {
      for (const val of value) {
        searchParams.append(key, val);
      }
    } else {
      searchParams.append(key, value);
    }
  }

  return searchParams.toString();
};
